import {
  ComponentRef,
  ComponentType,
  MouseEventHandler,
  forwardRef,
} from 'react';

import { IconButton } from '@opositandopn/ui';
import classnames from 'classnames';
import { TbCheck, TbX } from 'react-icons/tb';

import styles from './withSwitchButton.module.scss';

export interface InjectedProps {
  selected: boolean;
  onSwitch: () => void;
}

function withSwitchButton<T extends Record<string, unknown>>(
  WrappedComponent: ComponentType<T>,
) {
  type Props = T & InjectedProps;

  const Wrapper = forwardRef<ComponentRef<typeof WrappedComponent>, Props>(
    (props, ref) => {
      const { selected, onSwitch, ...restProps } = props;
      const { className, ...wrappedProps } = restProps as unknown as T & {
        className?: string;
      };

      return (
        <div className={styles['main']}>
          <WrappedComponent
            {...(wrappedProps as unknown as T)}
            ref={ref}
            className={classnames(styles['component'], className)}
          />
          {selected ? (
            <IconButton
              size="sm"
              className={classnames(styles['button'], {
                [styles[`button--success`]]: true,
              })}
              icon={<TbCheck />}
              onClick={
                onSwitch as MouseEventHandler<HTMLButtonElement> &
                  MouseEventHandler<HTMLDivElement>
              }
            />
          ) : (
            <IconButton
              size="sm"
              className={classnames(styles['button'], {
                [styles[`button--danger`]]: true,
              })}
              icon={<TbX />}
              onClick={
                onSwitch as MouseEventHandler<HTMLButtonElement> &
                  MouseEventHandler<HTMLDivElement>
              }
            />
          )}
        </div>
      );
    },
  );

  Wrapper.displayName = `WithWrapper(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return Wrapper;
}

export default withSwitchButton;
